import { ApiResource } from '@/core/models/ApiResource.interface';
import { Employee } from '../employees/employee.interface';
import { PersonSearchData } from './person.interface';

export class PersonService {
   async searchPersons(searchPersonsInput: PersonSearchData) {
      const response = await http.post<ApiResource<Array<Employee>>>(`/search-person`, {
         phone_number: searchPersonsInput.phone_number || null,
         person_name: `${searchPersonsInput.first_name || ''} ${searchPersonsInput.last_name || ''}`,
      });

      return response.data.data;
   }
}
